module.exports = __webpack_public_path__ + "media/images/logo-b54375793d4fa198f8f2858bf83d75f6.png";